import { useState, useEffect, useMemo } from "react";

import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  IconButton,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from "@mui/material";

import WithdrawalRow from "./WithdrawalRow";
import NormalRow from "./NormalRow";
import ForRoutingRow from "./ForRoutingRow";
import ForRoutingAdminRow from "./ForRoutingAdminRow";
import InventoryRow from "./InventoryRow";
import ClickAndCollectRow from "./ClickAndCollectRow";
import MailingRow from "./MailingRow";
import InventorySellerRow from "./InventorySellerRow";
import TableLoader from "./TableLoader";
import ForSellerAdminRow from "./ForSellerAdminRow";
import ForRoutingAdminOrderPickupsRow from "./ForRoutingAdminOrderPickupsRow";

function CustomTableNew(props) {
  const [filteredData, setFilteredData] = useState();

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const handleRequestSort = (property) => {
    let isSameProperty = "";

    props.setOrderByFilter((prevOrderByFilter) => {
      isSameProperty = prevOrderByFilter === property;
      const newOrderByFilter = isSameProperty ? prevOrderByFilter : property;
      return newOrderByFilter;
    });

    props.setOrderFilter((prevOrderFilter) => {
      if (!isSameProperty) {
        // If the property changes, reset to "asc"
        return "asc";
      } else {
        // Toggle between "asc" and "desc" for the same property
        return prevOrderFilter === "asc" ? "desc" : "asc";
      }
    });
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      props.setSelected(filteredData);
      return;
    }
    props.setSelected([]);
  };
  // ---- NOT USED ----
  const handleClick = (event, request) => {
    const selectedIndex = props.selected
      .map((req) => req.id)
      .indexOf(request.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(props.selected, request);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(props.selected.slice(1));
    } else if (selectedIndex === props.selected.length - 1) {
      newSelected = newSelected.concat(props.selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        props.selected.slice(0, selectedIndex),
        props.selected.slice(selectedIndex + 1)
      );
    }

    props.setSelected(newSelected);
  };
  // -------------------

  const handleChangePage = (newPage) => {
    props.setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    props.setRowsPerPage(parseInt(event.target.value, 10));
    props.setPage(1);
  };
  // ------ NOT USED -------
  const isSelected = (request) => {
    if (props.selected === "none") {
      return null;
    }
    return props.selected.map((req) => req.id).indexOf(request.id) !== -1;
  };
  // -------------------

  function TablePaginationActions() {
    let count = props.totalCount;
    let buttonsCount = Math.ceil(count / props.rowsPerPage);

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <Pagination
          count={buttonsCount}
          defaultPage={1}
          onChange={(_event, value) => props.setPage(value)}
          page={props.page}
        />
      </Box>
    );
  }

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      // Select only orders that have a non-empty order_id and a non-empty label
      const allOrderIds = props.pageData
        .filter((row) => row.order_id && row.label !== "") // Ensure both order_id and label are not empty
        .map((row) => row.order_id);

      props.setSelectedPrintLabels(allOrderIds);
    } else {
      // Unselect all
      props.setSelectedPrintLabels([]);
    }
  };

  const columnVisibility = useMemo(() => {
    return props.headerTable.reduce((acc, col) => {
      acc[col.dbName] = col.enabled;
      return acc;
    }, {});
  }, [props.headerTable]);

  return props.loadingPageData ? (
    <TableLoader />
  ) : props.totalCount === 0 ? (
    <p className="empty-data-text">
      {props.emptyDataText === undefined ? "No hay datos" : props.emptyDataText}
    </p>
  ) : (
    <>
      {" "}
      <TableContainer>
        <Table
          aria-label="collapsible table"
          className={
            props.collapseType === "for-routing-table" ? "fixed-table" : ""
          }
        >
          <TableHead>
            <TableRow>
              {/* Check all checkbox
              Show the checkbox to check or uncheck all
              */}
              {props.collapseType === "deliveries-resume" ? (
                <TableCell padding="checkbox" sx={{ minWidth: 80, paddingLeft: 2 }}>
                  <Checkbox
                    color="primary"
                    indeterminate={
                      props.selectedPrintLabels.length > 0 &&
                      props.selectedPrintLabels.length < props.pageData.length
                    }
                    checked={
                      props.selectedPrintLabels.length === props.pageData.length
                    }
                    onChange={handleSelectAll}
                    inputProps={{ "aria-label": "select all" }}
                  />
                </TableCell>
              ) : (
                ""
              )}

              {/*show all the rest of headers*/}

              {props.headerTable.map((header, index) =>
                header.columnName !== "check-all" && header.enabled ? ( // Hide the "check all" column to show only the previous check/uncheck all box
                  <TableCell key={`header-${index}`}>
                    {
                      header.columnName === "Destinatario" ? ( // If column, show the  ASC/DESC sorting options
                        <TableSortLabel
                          active={props.orderByFilter === header.dbName}
                          direction={
                            props.orderByFilter === header.dbName
                              ? props.orderFilter
                              : "asc"
                          }
                          onClick={() => handleRequestSort(header.dbName)}
                        >
                          {header.columnName}
                        </TableSortLabel>
                      ) : (
                        header.columnName
                      ) // ELSE, show the column wihtout sorting options
                    }
                  </TableCell>
                ) : null
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {props.pageData &&
              props.pageData.map((row, index) =>
                props.collapseType === "order-pickups" ? (
                  <ForRoutingAdminOrderPickupsRow
                    key={`order-pickup-${row.id}`}
                    pickup={row}
                    columns={props.headerTable}
                    fetchWithdrawals={props.fetchWithdrawals}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                  />
                ) : props.collapseType === "withdrawals-detail" ? (
                  <WithdrawalRow
                    key={`withdrawals-${index}`}
                    withdrawal={row}
                    columns={props.headerTable}
                    fetchWithdrawals={props.fetchWithdrawals}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                  />
                ) : props.collapseType === "products-inventory" ? (
                  <InventoryRow
                    key={`inventory-${index}`}
                    assignment={row}
                    columns={props.headerTable}
                    handleMoveAssignment={props.handleMoveAssignment}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                  />
                ) : props.collapseType === "products-inventory-seller" ? (
                  <InventorySellerRow
                    key={`inventory-seller-${index}`}
                    assignment={row}
                    columns={props.headerTable}
                    rowIndex={index}
                    // handleMoveAssignment={props.handleMoveAssignment}
                    color="#fff"
                  />
                ) : props.collapseType === "mailing-detail" ? (
                  <MailingRow
                    key={`mailing-${index}-${row.id}`}
                    mailing={row}
                    columns={props.headerTable}
                    openCollapseButton={props.openCollapseButton}
                    openCollapseTooltip={props.openCollapseTooltip}
                    openCollapseIcon={props.openCollapseIcon}
                    fetchMailings={props.fetchMailings}
                    current_user={props.current_user}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                  />
                ) : props.collapseType === "all-orders" ? (
                  <ForRoutingRow
                    key={`for-routing-${index}`}
                    request={row}
                    columns={props.headerTable}
                    selected={props.selected}
                    handleClick={handleClick}
                    isSelected={isSelected}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                    dateFilter={props.dateFilter}
                    orderTypes={props.orderTypes}
                  />
                ) : props.collapseType === "pending-orders" ? (
                  <ForRoutingRow
                    key={`for-routing-${index}`}
                    request={row}
                    columns={props.headerTable}
                    selected={props.selected}
                    handleClick={handleClick}
                    isSelected={isSelected}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                    dateFilter={props.dateFilter}
                    orderTypes={props.orderTypes}
                  />
                ) : props.collapseType === "deliveries-resume" ? (
                  <ForRoutingAdminRow
                    key={`for-routing-${index}`}
                    request={row}
                    columns={props.headerTable}
                    selected={props.selected}
                    handleClick={handleClick}
                    isSelected={isSelected}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                    dateFilter={props.dateFilter}
                    selectedPrintLabels={props.selectedPrintLabels}
                    setSelectedPrintLabels={props.setSelectedPrintLabels}
                    columnVisibility={columnVisibility}
                  />
                ) : props.collapseType === "sellers-list" ? (
                  <ForSellerAdminRow
                    key={`for-routing-${index}`}
                    request={row}
                    columns={props.headerTable}
                    selected={props.selected}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                  />
                ) : props.collapseType === "click-collect-orders" ? (
                  <ClickAndCollectRow
                    key={`click-collect-${row.id}`}
                    request={row}
                    columns={props.headerTable}
                    selected={props.selected}
                    handleClick={handleClick}
                    isSelected={isSelected}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                    dateFilter={props.dateFilter}
                    orderTypes={props.orderTypes}
                  />
                ) : (
                  <NormalRow
                    key={`row-${index}`}
                    request={row}
                    columns={props.headerTable}
                    color={index % 2 ? "#EFEFEF" : "#fff"}
                  />
                )
              )}
          </TableBody>
        </Table>
      </TableContainer>{" "}
      {props.hasPagination !== undefined &&
        props.hasPagination &&
        props.pageData && (
          <TablePagination
            rowsPerPageOptions={
              props.rowsPerPageOptions !== undefined
                ? props.rowsPerPageOptions
                : [20, 40, 60, 80, 100]
            }
            component="div"
            count={props.totalCount}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            onPageChange={(event) => handleChangePage(event)}
            onRowsPerPageChange={(event) => handleChangeRowsPerPage(event)}
            labelDisplayedRows={({ from, to, count }) => {
              return `Mostrando ${from}-${to} de ${count}`;
            }}
            labelRowsPerPage={"Filas por página:"}
            ActionsComponent={TablePaginationActions}
          />
        )}
    </>
  );
}

export default CustomTableNew;
